import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { adminApi } from "@/lib/adminApi";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return toast.error("Les mots de passe ne correspondent pas");
    if (pwd.length < 10) return toast.error("Minimum 10 caractères");
    setLoading(true);
    try {
      await adminApi.post("/auth/reset", { token, new_password: pwd });
      toast.success("Mot de passe modifié — vous pouvez vous reconnecter");
      nav("/admin/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div className="min-h-screen bg-[#0b1220] text-slate-100 flex items-center justify-center px-6">
      <p>Lien invalide. <Link to="/admin/login" className="text-emerald-400 underline">Retour</Link></p>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0b1220] text-slate-100 flex items-center justify-center px-6" data-testid="admin-reset-page">
      <div className="w-full max-w-md">
        <div className="bg-[#0f172a] border border-slate-800 rounded-xl p-8 shadow-2xl">
          <h1 className="text-2xl font-semibold mb-2">Nouveau mot de passe</h1>
          <p className="text-sm text-slate-400 mb-6">Choisissez un mot de passe fort (10 caractères minimum).</p>
          <form onSubmit={submit} className="space-y-4">
            <input type="password" required minLength={10} value={pwd} onChange={(e) => setPwd(e.target.value)}
              data-testid="admin-reset-pwd" placeholder="Nouveau mot de passe"
              className="w-full bg-[#0b1220] border border-slate-700 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-emerald-500/50" />
            <input type="password" required minLength={10} value={pwd2} onChange={(e) => setPwd2(e.target.value)}
              data-testid="admin-reset-pwd2" placeholder="Confirmer"
              className="w-full bg-[#0b1220] border border-slate-700 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-emerald-500/50" />
            <button type="submit" disabled={loading} data-testid="admin-reset-submit"
              className="w-full bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white font-medium py-2.5 rounded-md text-sm inline-flex items-center justify-center gap-2">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Valider
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
